import { useDevices } from "@/store/devices";
type ControlsVersions = { [key in CameraControlKey]: number };

const controlsVersions: ControlsVersions = {
  face: 1,
  flashlight: 1,
  history: 1,
  mute: 1,
  scale_video: 1,
  switch_camera: 1,
  replay: 1,
  low_light_mode: 1,
  alarm: 2,
  record: 3
};

const updateDevice = useDevices.getState().updateExistingDevice;

export const resolveCameraControls = (device: StoreCameraDevice, actionController: ActionController) => {
  const { primaryControls, secondaryControls: immutable, version = 1 } = device.cameraControls;
  const { mapKeys: knownKeys } = actionController;

  const secondaryControls: CameraControlKeys = [...immutable];
  let keysNotFoundInControls: CameraControlKeys = [];
  let shouldUpdateDevice = false;

  knownKeys.forEach((key) => {
    if (!primaryControls.includes(key) && !secondaryControls.includes(key)) keysNotFoundInControls.push(key);
  });

  const supportedFeatures = device.supportedFeatures;
  keysNotFoundInControls = keysNotFoundInControls.filter((key) => {
    const controlVersion = controlsVersions[key];
    if (controlVersion <= 1) {
      return false;
    }
    if (!supportedFeatures?.includes("CAMERA_STATION_VIDEO_RECORDING") && key === "record") {
      return false;
    }
    if (supportedFeatures?.includes("CAMERA_STATION_FLASHLIGHT_NOT_SUPPORTED") && key === "flashlight") {
      return false;
    }
    if (supportedFeatures?.includes("CAMERA_STATION_LOW_LIGHT_NOT_SUPPORTED") && key === "low_light_mode") {
      return false;
    }
    return true;
  });

  if (keysNotFoundInControls.length > 0) {
    keysNotFoundInControls.forEach((key) => {
      log.monitoring(`key '${key}' not found in controls`);
      const controlVersion = controlsVersions[key];
      if (controlVersion > version) {
        secondaryControls.unshift(key);
        log.monitoring(`Adding key '${key}' to secondary controls`);
        shouldUpdateDevice = true;
      }
    });

    if (shouldUpdateDevice)
      updateDevice({
        jid: device.jid,
        cameraControls: { ...device.cameraControls, version: getControlsVersion(), secondaryControls }
      });
  }
};

export const getControlsVersion = () => {
  return Math.max(...Object.values(controlsVersions));
};
